import React, { ReactNode } from 'react';

export type Dictionary = {
  certification: string;
  since: string;
  notAvailableAnymore: string;
  workingHours: string;
  commuteDistance: string;
  relocation: string;
  salary: string;
  preferredJobs: string;
  total: string;
  unableToRefresh: string;
  current: string;
  past: string;
  today: string;
  noDataAvailable: string;
  cvAvailable: string;
  hours: string;
  copyText: string;
  copy: string;
  pasteJobDescription: string;
  saveJobRequiredFields: string;
  searchVacancy: string;
  moreJobDetailsNeeded: string;
  errorProcessingVacancy: string;
  errorProcessingAtsVacancy: string;
  youCannotImproveAlreadyImprovedVacancy: string;
  /* ---- start: added by AI ---- */
  failedToProcessAtsVacancyMissing: (params: { missingFields: string }) => string;
  /* ---- end: added by AI ---- */

  login: string;
  rememberMe: string;
  logout: string;
  registerAccount: string;
  newCompany: string;
  required: string;
  notRequired: string;
  questionnaireMustHave: string;
  questionnaireNiceToHave: string;
  questionnaireDoesntMatch: string;
  questionnaireCandidateColumn: string;
  questionnaireRequirementColumn: string;
  questionnaireMustHaveTooltip: ReactNode;
  showPassword: string;
  hidePassword: string;
  forgotPassword: string;
  forgotYourPassword: string;
  forgotPasswordDescription: string;
  resetPassword: string;
  multiFactorAuth: string;
  enterMultiFactorAuthCode: string;
  resetPasswordMailSentDescription: string;
  mailSent: string;
  pleaseEnterYourNewPassword: string;
  preferences: string;
  email: string;
  emailNotifications: string;
  sendEmail: string;
  username: string;
  userName: string;
  password: string;
  passwordRepeat: string;
  overview: string;
  new: string;
  viewAll: string;
  statistics: string;
  comingSoon: string;
  administration: string;
  connections: string;
  availableCredits: (left: number, total: number, isPayPerMatch?: boolean) => ReactNode;
  profile: string;
  cv: string;
  emailAddress: string;
  emailAddressForTeams: string;
  phoneNumber: string;
  nickname: string;
  companyName: string;
  companiesWorkedAt: string;
  companiesWorkedAtPlaceholder: string;
  companySize: string;
  companyType: string;
  selectCountry: string;
  selectATS: string;
  whatATSAreYouUsing: string;
  howDidYouHearAboutUs: string;
  pleaseExplain: string;
  save: string;
  submit: string;
  next: string;
  previous: string;
  back: string;
  cancel: string;
  saveChanges: string;
  changePassword: string;
  currentPassword: string;
  newPassword: string;
  repeatNewPassword: string;
  chooseFile: string;
  noFileChosen: string;
  roles: string;
  users: string;
  user: string;
  ats: string;
  atsCompleteName: string;
  addedToAts: string;
  jobBoards: string;
  useRolesToGroupPermissions: string;
  manageUsersAndPermissions: string;
  recruitmentAgency: string;
  corporate: string;
  freelancer: string;
  selectInHouseRecruiters: string;
  cantBeLessThanZeroRecruiters: string;
  thisFieldIsRequired: string;
  validationRequiredEmail: string;
  useYourWorkEmailAddress: string;
  validationPasswordConfirm: string;
  editCriteriaForMoreResults: string;
  newResultsInHours: (hours: number) => ReactNode;
  newResultsOnMonday: string;
  thereAreNewResults: (newResults: number) => string;
  untitledSearch: string;
  newSearch: string;
  searches: string;
  candidates: string;
  teamView: string;
  teamview: string;
  status: string;
  lastAdded: string;
  coWorker: string;
  search: string;
  sortBy: string;
  sortedBy: string;
  mySearches: string;
  teamSearches: string;
  allSearches: string;
  allShortlisted: string;
  allContacted: string;
  allMatched: string;
  allHidden: string;
  searchOverview: string;
  campaignNotificationByEmail: string;
  campaignNotificationDisabled: string;
  campaignNotificationOnce: string;
  campaignNotificationTwice: string;
  campaignNotificationThrice: string;
  sendToNotificationTitle: string;
  sendToNotificationPersonal: string;
  sendToNotificationTeam: string;
  sendToNotificationBoth: string;
  askBeforeSpendingMonsterInventoryCredit: string;
  /// TODO WERKZOEKEN: Remove this after release new jobboard
  // askBeforeSpendingWerkzoekenCredit: string;
  yesAskEveryTime: string;
  noNeverAsk: string;
  browserExtension: string;
  robinExtension: string;
  adminPanel: string;
  intakePlanned: string;

  yes: string;
  no: string;
  areYouSure: string;
  confirmDeleteCampaign: string;
  by: string;
  in: string;
  you: string;
  here: string;

  match: string;
  shortlistCandidateToOtherSearch: string;
  shortlistCandidateNameToOtherSearch: (name: string) => string;
  shortlistCandidateToOtherSearchDescription: string;
  reTriggerATSCandidateSync: string;
  hideFromApproved: string;

  matched: string;
  hidden: string;
  shortlist: string;
  shortlisted: string;
  unsaved: string;
  saved: string;
  connectToAts: string;
  connectToAtsVacancy: string;
  unlocked: string;
  downloadProfiles: string;
  history: string;
  activity: string;
  profileHistoryPlaceholder: string;
  details: string;
  educationLevel: string;
  employer: string;
  travelDistance: string;
  availability: string;
  contactInfo: string;
  Monsterboard: string;
  Nationalevacaturebank: string;
  Werknl: string;
  version: string;
  downloadAllApprovedCandidates: string;
  downloadAllAMatched: string;
  maxOf300CandidatesWillBeDownloaded: string;
  searchForAts: string;

  iAlreadyKnow: string;
  overqualified: string;
  underqualified: string;
  wrongIndustry: string;
  wrongEducation: string;
  wrongExperience: string;
  tooFarAway: string;
  otherReasonNamely: string;
  other: string;
  hide: string;
  check: string;

  contact: string;
  contacted: string;
  calendarInterviewInvitationSent: string;
  calendarInterviewInvitationAccepted: string;
  calendarInterviewInvitationRescheduled: string;
  calendarInterviewInvitationRejected: string;
  calendarBookingStart: string;
  calendarBookingDurationMinutes: (minutes: number) => string;
  positiveResponse: string;
  negativeResponse: string;
  noResponse: string;
  searching: string;
  sentToAts: string;
  sentToYourAts: string;
  jobTitleAndLabel: (jobTitle: string, label: string) => string;
  interviewScheduled: string;
  interviewBookedToastTitle: string;
  interviewBookedToastMessage: (name: string) => string;
  interviewPlaneed: string;
  interviewCompleted: string;
  interviewCancelled: string;
  leftVoicemail: string;
  openToWorkNotInterested: string;
  notOpenToWork: string;
  noResponsiveToReachout: string;

  experience: string;
  courses: string;
  certifications: string;
  reference: string;
  education: string;
  skill: string;
  skills: string;
  language: string;
  languages: string;
  volunteerWork: string;
  industry: string;
  company: string;
  date: string;

  whyRejected: string;
  whatIsTheStatus: string;
  updateStatus: string;

  //FORM
  explanation: string;
  nameSearch: string;
  vacancy: string;
  vacancyPlaceholder: string;
  jobTitle: string;
  jobTitles: string;
  jobTitlesTooltip: React.ReactNode;
  addSuggestions: (number: number) => string;
  jobTitlePlaceholder: string;
  addJobTitlePlaceholder: string;
  jobTitleWarning: string;
  workExperience: string;
  minWorkExperienceInYears: string;
  maxWorkExperienceInYears: string;
  minWorkExperienceInFunction: string;
  screeningCriteria: string;
  screeningCriteriaPlaceholder: string;
  country: string;
  postalCode: string;
  rangeInKm: string;
  startSearch: string;
  editSearch: string;
  eg: string;
  errorDuplicatedJobTitle: string;

  veryWell: string;
  iWillStartLookingForCandidates: (campaignName: string) => ReactNode;
  whatToExpect: string;
  whatToExpect1: string;
  whatToExpect2: string;
  editThisCampaign: string;
  viewCampaigns: string;
  searchForCampaign: string;
  ratioOfApprovedCandidates: (approved: number, total: number) => ReactNode;
  seeResults: string;
  notAbleDeleteSearchAts: string;

  more: string;
  move: string;
  moveTo: string;

  contactInfoSetting: string;
  activeJobSeekersSetting: string;
  newLink: string;
  insertLink: string;
  displayText: string;
  URL: string;
  removeLink: string;
  attachFile: string;
  tokensEmpty: string;

  //Job Boards
  newJobBoard: string;
  editJobBoard: string;
  invalidCredentials: string;
  validATSCredentials: string;
  invalidMfaCode: string;
  credentialsExpired: string;
  jobBoardCredentialVerificationTitle: string;
  jobBoardCredentialVerificationDescription: string;
  jobBoardInvalidCredentials: string;
  jobBoardDuplicatedCredentials: string;
  jobBoardConnectionActive: string;
  jobBoardConnectionInActive: string;
  confirmDeleteJobBoard: string;
  confirmDisableJobBoard: string;
  jobBoardExplanation: string;
  jobBoardUsernameExplanation: string;
  jobBoardPasswordExplanation: string;
  jobBoardSecret: string;
  jobBoardSecretExplanation: string;
  licenseActive: string;
  licenseInActive: string;
  license: string;
  addLicense: string;

  //ATS
  addNew: string;
  atsVacancy: string;
  viewATSConnections: string;
  unableToConnectToATS: string;
  myConnections: string;
  teamConnections: string;
  usersWithoutConnections: string;
  atsKey: string;
  atsUrl: string;
  atsName: string;
  clientSecret: string;
  requestATSConnection: string;
  atsRequestedMessage: ReactNode;
  checkOverview: string;
  confirmDeleteATS: string;
  confirmSwitchATS: (ats: string) => ReactNode;
  atsExplanation: string;
  atsUsernameExplanation: string;
  atsPasswordExplanation: string;
  atsKeyExplanation: string;
  atsSecret: string;
  atsSecretExplanation: string;
  atsConnectionAltTitle: (id: number, name: string) => string;
  recruiteeWebhookInstruction: string;
  webhookUrl: string;
  webhookSecret: string;
  seeDetails: string;
  /// ATS Credentiasl error Modal
  showMoreErrorDetails: string;
  atsCredentialsErrorModalBody: string;
  atsPermissionOk: string;
  atsPermissionInvalid: string;

  campaignCompletedTitle: string;
  campaignCompletedMessage: ReactNode;
  campaignGroup1CompletedMessage: ReactNode;
  searchingMoreProfiles: string;
  searchAgain: string;
  reviewAlternativeCandidates: string;

  mustBeLessThanMax: string;
  mustBeMoreThanMin: string;

  // common
  any: string;
  of: string;
  add: string;
  edit: string;
  delete: string;
  activate: string;
  deactivate: string;
  close: string;
  remove: string;
  exclude: string;
  mustHave: string;
  saving: string;
  done: string;
  loading: string;
  thisCouldTakeAFewMinutes: string;
  changesSaved: string;
  invalidUsername: string;
  invalidPassword: string;
  clickHere: string;
  selectAll: string;
  selectAllCandidatesWithRj: string;
  selectCandidates: string;
  rjBulkSelectAllDailyLimitTooltip: string;
  runRjAmount: (value: number) => string;
  rjBulkOutreachesUsagePillLabel: (used: number, total: number) => string;
  amountLeftToday: (value: number) => string;
  rjBulkDailyContactLimitDescription: (value: number) => string;
  rjBulkOutreachesLeftToday: (value: number) => string;
  rjBulkDailyLimitReachedQuotaResetsTomorrow: string;
  candidatesSelectedCount: (value: number) => string;
  clearAll: string;
  scrollTo: string;
  otherwiseNamely: string;
  somethingWentWrong: string;
  pleaseTryAgainOrContactUs: string;
  indeedCandidateAlreadyContacted: string;
  indeedCandidateEngagementFailed: string;
  indeedCandidateRecentlyDeclined: string;
  indeedCandidateSubscriptionMismatch: string;
  notFound: string;
  loggingYouInAutomatically: string;
  couldNotLogYouInAutomatically: string;
  attemptNofX: (current: number, max: number) => string;
  minimumCharacterValue: (value: string | number) => string;
  maximumCharacterValue: (value: string | number) => string;
  companyNameCannotContainSpecialCharacters: string;
  selectAnOption: string;
  and: string;
  or: string;
  expandLess: string;
  expandMore: string;
  downloadProfile: string;
  tutorial: string;
  emailSuccessfullySent: string;
  emailFailedSend: string;
  linkedinSuccessfullySent: string;
  linkedinFailedSend: string;
  linkedinInMailSuccessfullySent: string;
  liknedinInMailFailedSend: string;
  indeedSuccessfullySent: string;
  indeedFailedSend: string;

  //Languages
  english: string;
  dutch: string;

  //Users
  actions: string;
  exportToExcel: string;
  createNewUser: string;
  manageUsers: string;
  userActivationSettings: string;
  isActive: string;
  userUnlock: string;
  lastLoggedIn: string;
  userSince: string;
  emailConfirmed: string;

  userCreatedSuccessfully: string;
  userProfileUpdatedSuccessfully: string;
  userDeactivateConfirmation: string;
  userActivateConfirmation: string;
  userWasUnlockedSuccessfully: string;
  userWasDeletedSuccessfully: string;
  userWasActivatedSucessfully: string;

  editUser: string;
  invalidEmailAddress: string;
  invalidPhoneNumber: string;
  atLeast6Characters: string;
  atLeast12Characters: string;
  passwordMustContainDigit: string;
  passwordMustContainUppercase: string;
  passwordMustContainLowercase: string;

  userPasswordSettings: string;
  setRandomPasswordForUser: string;
  setNewPassword: string;
  shouldChangePasswordOnNextLogin: string;
  sendActivationEmail: string;
  setUserIsActive: string;
  setLockOut: string;
  remindPassword: string;
  incorrectPassword: string;
  passwordsDoNotMatch: string;
  passwordIsTheSame: string;

  //While the user is logged out
  emailActivation: string;
  emailActivationDescription: string;
  emailActivationSentDescription: string;

  invalidResetLink: string;
  invalidResetLinkDescription: string;
  passwordResetComplete: string;
  goToLogin: string;
  goToLoginDescription: string;

  companyNameIsTaken: string;

  //Realtime Search filters
  activeFilters: (num: number) => string;
  filters: string;
  totalExperience: string;
  location: string;
  locations: string;
  locationsPlaceholder: string;
  skillsKeywords: string;
  skillsKeywordsPlaceholder: string;
  mustHaveEmail: string;
  mustHavePhone: string;
  sources: string;
  schoolName: string;
  schoolNamePlaceholder: string;
  educationDegree: string;
  educationDegreePlaceholder: string;
  educationFields: string;
  educationFieldsPlaceholder: string;
  sizeOfBatches: string;
  locationDistanceInKm: string;
  searchResults: string;
  updatedAt: string;
  graduationYear: string;
  employmentType: string;

  //Updated At Filter
  anyTime: string;
  last24Hours: string;
  last3Days: string;
  lastWeek: string;
  lastMonth: string;
  last3Months: string;
  last6Months: string;
  lastYear: string;

  //Employment Type Filter
  employmentTypeFullTime: string;
  employmentTypePartTime: string;
  employmentTypeInternship: string;
  employmentTypeFreelance: string;
  employmentTypeShortTerm: string;
  employmentTypeSeasonal: string;

  //Job Title Type Filter
  jobTitleType: string;
  jobTitleTypeAll: string;
  jobTitleTypeCurrent: string;
  jobTitleTypeRecent: string;
  jobTitleTypePast: string;

  //Realtime Search Results
  candidatePreferences: string;
  interests: string;
  source: string;
  lastUpdated: string;
  lastCrawled: string;
  lastMatched: string;
  lastShortlisted: string;
  lastContacted: string;
  lastHidden: string;
  couldNotRefreshProfile: string;
  profileNotAvailable: string;
  phone: string;
  academicExperience: string;
  addSomeFiltersMessage: string;
  noResultsMessage: string;
  industries: string;
  aboutMe: string;
  licenses: string;
  openToWork: string;
  autoSavedFilters: string;
  credentialsDisabledCallToAction: (platform: string) => string;

  helpCenter: string;

  help: string;

  notifications: string;
  markNotificationAsRead: string;
  markAllAsRead: string;
  seeSearchInList: string;
  year: string;
  years: string;
  month: string;
  months: string;
  inTotal: string;
  inFunction: string;
  viewFullProfile: string;
  pleaseWait: string;
  downloadCV: string;
  downloadCVs: string;
  pageNumOfNum: (current: number | string, total: number | string) => string;
  issued: string;
  resume: string;
  licensesAndCertifications: string;
  jobs: string;
  minWorkHours: string;
  maxWorkHours: string;
  minSalary: string;
  maxSalary: string;
  currency: string;
  unlockContactInformation: (price: number) => string;
  saveAndUnlockContactInformation: (price: number) => string;
  unlockCV: (price: number) => string;
  currentOfTotal: (current: number | string, total: number | string) => string;
  showMore: string;
  showLess: string;
  showXMore: (quantity: number) => string;
  showXLess: (quantity: number) => string;
  showAll: (quantity: number) => string;
  plusMore: (quantity: number) => string;
  requestContactInformation: string;
  youCanRequestContactInformation: string;
  thisProfileWasUpdatedTimeAgo: (timeAgo: string) => string;
  thisProfileWasRefreshedTimeAgo: (timeAgo: string) => string;
  thisProfileWasApprovedTimeAgo: (timeAgo: string) => string;
  loading_ats_synchronization_label: string;
  loading_contact_info_label: string;
  userFormGenericError: string;
  userFormEmailAlreadyTakenError: string;
  errorSectionTitle: string;
  errorSectionMissingSkillOrFunction: string;
  duplicate: string;
  copyOf: string;
  clickHereToUpdateSearch: string;
  orSimplyPress: (params: { isMacOs: boolean }) => ReactNode;

  // Teams
  team: string;
  teams: string;
  teamName: string;
  teamUsers: string;
  manageTeams: string;
  createNewTeam: string;
  createdBy: string;
  createdAt: string;
  editTeam: string;
  teamDeletionConfirmation: string;
  teamWasDeletedSuccessfully: string;
  teamCreatedSuccessfully: string;
  teamUpdatedSuccessfully: string;
  editTenantEmailSettingsBtn: string;
  editTenantEmailSettings: string;
  editTenantEmailSettingsExplanation: string;
  tenantEmailSettingsCreatedSuccessfully: string;
  tenantEmailSettingsUpdatedSuccessfully: string;
  joinTeamSuccessfully: string;
  exitTeamSuccessfully: string;
  join: string;
  leave: string;
  detailsTeam: string;

  updateContactInformation: string;
  contactInfoAvailableFrom: (platform: string) => string;
  requestHere: string;
  refreshHappensAutomatically: string;
  notificationJobbboardNewVersion: (platform: string) => string;
  requestJobboardInformationConfirmationTitle: (platform: string) => string;
  requestJobboardInformationConfirmationDescription: (platform: string) => string;
  requestJobboardInformationConfirmationCancelText: string;
  requestJobboardInformationConfirmationConfirmText: string;

  dontPerformThisCheckNextTime: string;

  candidateNotFoundTitle: string;
  candidateNotFoundSubtitle: string;

  /// Platforms
  whatsApp: string;
  linkedIn: string;
  linkedInInMail: string;
  indeed: string;

  /// ContactModal
  chooseContactTitleModal: string;
  chooseContactDescriptionModal: (name: string) => string;
  writeEmailTo: (name: string) => string;
  writeMessageTo: (name: string) => string;
  sendWithWhatsAppWeb: string;
  sendWithIndeed: string;
  sendLinkedInRequest: string;
  sendMessage: string;
  sendInMail: string;
  sentWhatsAppTo: (name: string) => string;
  sentEmailTo: (name: string) => string;
  sentOutreachMessageTo: (channel: string, candidateName: string) => string;
  emailSent: string;
  emailReceived: string;
  emailReceivedFrom: (name: string) => string;
  reply: string;
  indeedSent: string;
  indeedReceived: string;
  indeedJobDropdownPlaceholder: string;
  indeedNoJob: string;
  indeedNoJobsFound: string;
  indeedProjectDropdownPlaceholder: string;
  whatsappSent: string;
  linkedinConnectionSent: string;
  linkedinInmailSent: string;
  sentIndeedTo: (name: string) => string;
  sentLinkedInTo: (name: string) => string;
  sentLinkedInMailTo: (name: string) => string;
  sentWerknlMailTo: (name: string) => string;
  sentBy: string;
  sendDisabledIndeedTip: string;
  sendDisabledLinkedinTip: string;

  callingWith: (candidateName: React.ReactNode) => React.ReactNode;
  sendEmailTo: (candidateName: string) => string;
  sendWhatsAppMessageTo: (candidateName: string) => string;
  sendIndeedMessageTo: (candidateName: string) => string;
  replyIndeedMessageTo: (candidateName: string) => string;
  sendWerknlMessageTo: (candidateName: string) => string;
  newLinkedinMessageTo: (candidateName: string) => string;
  newLinkedinInMailMessageTo: (candidateName: string) => string;

  /// Connect Phone Modal
  connectYourPhoneTitleModal: string;
  connectYourPhoneDescriptionModal: string;
  showMeHow: string;
  dontShowThisAgain: string;
  imConnected: string;
  downloadTheApp: string;

  /// Browser Extension Modal
  browserExtensionRequired: string;
  browserExtensionRequiredDescriptionModal: string;
  installTheExtension: string;

  /// Confirm Message Modal
  confirmMessageTitleModal: string;
  confirmMessageDescriptionModal: string;
  messageNotSent: string;
  generatingMessage: (name: string) => string;
  errorGeneratingMessage: (candidateName: string) => string;
  failureToSendMessageTo: (name: string) => string;
  messageSent: string;

  /// Confirm Call Modal
  confirmCallTitleModal: (name: string) => string;
  confirmCallDescriptionModal: string;
  couldntConnect: string;
  connected: string;
  callSaved: string;

  /// Fields tips
  campaignNotificationByEmailTip: string;
  nameSearchTip: string;
  jobTitleTip: string;
  jobTitleTypeTip: string;
  locationDistanceInKmTip: string;
  contactInfoTip: string;
  totalExperienceTip: string;
  languagesTip: string;
  lastUpdatedTip: string;
  graduationYearTip: string;
  schoolNameTip: string;
  educationDegreeTip: string;

  /// Admin
  backToSearchCampaigns: string;
  createNewCompany: string;
  editCompany: string;
  editUsers: string;
  impersonateUser: string;
  creditLimit: string;
  updateUsersSuccessfully: string;
  id: string;
  companyCode: string;
  edition: string;
  active: string;
  inactive: string;
  credits: string;
  created: string;
  updated: string;
  demo: string;
  standard: string;
  tenantHasBeenUpdatedSuccessfully: string;
  tenantHasBeenCreatedSuccessfully: string;
  tenantName: string;
  removeSpaces: string;
  subscriptionEdition: string;
  editTenantUsers: string;
  editTenantUsersSubtitle: string;
  name: string;
  firstName: string;
  lastName: string;
  fullName: string;
  lastPosition: string;
  lastCompany: string;
  recruiterFullName: string;
  nameJobboard: string;
  nameVacancy: string;
  addAnotherUser: string;
  impersonate: string;
  searchCompany: string;
  entriesPerPage: string;

  matchPhase: string;
  none: string;

  website: string;

  typeYourMessage: string;
  typeYourMessageRobinJr: string;
  selectHighQualityJob: string;
  typeYourNote: string;
  subject: string;
  signOff: string;
  featureToggles: string;
  addFeatureToggle: string;
  featureTogglesSearchPlaceholder: string;
  featureTogglesNewLayout: string;
  featureTogglesEmptyTitle: string;
  featureTogglesEmptyDescription: string;
  featureTogglesNoResultsTitle: string;
  featureTogglesCreateNamed: (name: string) => string;
  featureTogglesFilterOn: string;
  featureTogglesFilterOff: string;
  featureTogglesStatusNew: string;
  featureTogglesStatusEdited: string;
  featureTogglesStatusRemoved: string;
  featureTogglesDuplicateName: string;
  featureTogglesNotSavedYet: string;
  featureTogglesUnsavedChanges: (count: number) => string;
  featureTogglesDone: string;
  featureTogglesCopyName: string;
  featureTogglesNameCopied: string;
  undo: string;
  title: string;
  value: string;
  enabled: string;
  emptySubject: string;
  emptyMessage: string;
  emptySignOff: string;
  yearAbbr: string;
  yearsAbbr: string;
  simplified: string;
  addLabels: string;
  addLabel: string;
  labelAdded: string;
  noteAdded: string;
  fresh: string;
  candidateHasXNotes: (labelsCount: number) => string;

  // Candidates Insights
  newCandidate: string;
  updatedInformation: string;
  educationAddedRecently: string;
  educationDatesChanged: string;
  educationEditedRecently: string;
  experienceAddedRecently: string;
  jobRoleChanged: string;
  jobDescriptionChanged: string;
  jobDatesChanged: string;
  skillAddedRecently: string;
  preferredEmploymentTypeChanged: string;
  preferredWorkHoursChanged: string;
  workAvailabilityChanged: string;
  locationChangedRecently: string;
  phoneAddedRecently: string;
  phoneNumberChanged: string;
  emailAddedRecently: string;
  emailChanged: string;

  latestActions: string;

  titlePlaceholder: string;

  refineTheSearchBelow: string;

  indeedNoCredits: string;
  indeedCreditsUnknown: string;
  indeedCreditsOutOfSync: string;
  indeedCreditsOutOfSyncDescription: string;
  indeedCheckBalance: string;
  linkedinNoCredits: string;

  createNewTemplate: string;
  nameYourTemplate: string;
  blankTemplate: string;
  saveTemplate: string;
  selectTemplateToUse: (type: string) => string;
  templateSavedSuccessfully: string;
  templateTokens: string;
  lastActioned: string;
  oldestActioned: string;
  haveSeenItAll: string;
  sharedByFromSearch: (params: { userName: React.ReactNode; searchName: React.ReactNode }) => React.ReactNode;
  copyLinkCandidateProfile: string;
  linkCopySuccess: string;
  linkCopyFail: string;
  youNotHaveAccessProfile: string;
  tryResendAts: string;
  emailAndPhoneAvailableUponApproval: (email: boolean, phone: boolean) => string;
  cvAvailableUponApproval: string;

  changeOwner: string;
  currentOwner: string;
  makeUserSearchOwner: (userName: string) => string;
  makeUserSearchOwnerDescription: (userName: string) => string;
  goAhead: string;
  currentSearch: string;
  labelsChanged: string;
  notes: string;
  deleteNote: string;
  editNote: string;
  startTypingYourNotesHere: string;
  moreInfoSent: string;
  noAnswer: string;
  notResponding: string;
  notInterested: string;
  interested: string;
  showQuestionnaire: string;
  declined: string;
  positiveOutcomes: string;
  neutralOutcomes: string;
  negativeOutcomes: string;
  customLabels: string;
  createCustomLabel: string;
  removed: string;
  paymentMethod: string;
  triggerToSendCandidateToAts: string;
  chooseAnOption: string;
  selectATemplateToUse: (type: SelectAnTemplateToUseTypes) => string;
  templates: string;
  whatsAppTemplatesDisabledTitle: string;
  whatsAppTemplatesDisabledDescription: string;
  whatsAppTemplatesDisabledLearnMore: string;
  whatsAppTemplatesDisabledHide: string;
  whatsAppTemplatesDisabledReasonSameText: string;
  whatsAppTemplatesDisabledReasonPersonalize: string;
  whatsAppTemplatesDisabledReasonSpread: string;
  templateName: string;
  nameTheTemplate: string;
  newOutreach: string;
  content: string;
  connectYourCalendar: string;
  configureYourCalendar: string;
  yourCalendarIsConnected: string;
  yourCalendarIsNotConnected: string;
  openSettings: string;
  calendarSettings: string;
  toUseInterviewScheduler: string;
  signature: string;
  signatureSave: string;
  signaturePlaceholder: string;
  signatureDescription: string;
  signatureImageHelper: string;
  signatureSaving: string;
  signatureSaveError: string;
  signaturePullButton: string;
  signaturePullErrorTitle: string;
  signaturePullErrorBody: React.ReactNode;
  addManually: string;
  addSignatureManually: string;
  enableProviderFirst: string;
  signatureSaveErrorImageConversion: string;
  signatureSaveSuccess: string;
  manualSignatureSelectionTitle: string;
  manualSignatureSelectionDescription: React.ReactNode;
  manualSignatureSelectionCapture: string;
  manualSignatureSelectionInsert: string;
  manualSignatureSelectionPreview: string;
  manualSignatureSelectionHighlightError: string;
  calling: string;
  candidateNotes: string;
  successfull: string;
  candidateSentToAts: (candidateFirstName: string, atsName: string) => ReactNode;
  candidateNotSentToAts: string;
  candidateMissingContactInfoForAts: string;
  searchNotConnectedToAtsJob: string;
  unsuccessfull: string;
  findMoreGreatCandidates: string;
  tryAnotherOutreachMethod: string;
  outreachPhoneSuccessfullHeaderText: string;
  outreachPhoneUnsuccessfullHeaderText: string;
  filterByLabel: string;
  atsJobStatusesSelectionLabel: string;
  atsJobLabelsSelectionLabel: string;
  atsCandidateStatusesSelectionLabel: string;
  atsConnexysJobStatusDefaultFilterNotice: string;
  outreachResponseNoticeEmail: React.ReactNode;
  outreachResponseNoticeWhatsApp: string;
  outreachResponseNoticeInMail: string;
  outreachResponseNoticeLinkedIn: string;
  outreachResponseNoticeIndeed: string;
  outreachResponseNoticeWerknl: React.ReactNode;
  jobboardRestrictionMessage: (days: number, platform: string) => string;
  unavailableOnThisContactMethod: string;
  browserExtensionNotInstalled: string;
  needsLoginOnJobboard: string;
  needsConnectMobileApp: string;
  notesModificationHistory: string;
  lastEditedBy: string;
  seeFullHistory: string;
  emailCandidate: string;
  callCandidate: string;
  workingOnIt: string;
  call: string;
  callMobileByPushNotification: string;
  searchNameOrOwnerOfTheSearch: string;
  candidateNoLongerAvailable: string;
  canceledByUser: string;
  callingIsAutomaticDescription: string;
  makeActive: string;
  makeInactive: string;
  filterBy: string;
  lastContactedBy: (params: { when: string }) => string;
  noTemplateAvailable: string;
  createNewSearch: string;
  creatingNewSearch: string;
  default: string;
  aiLanguageSelector: {
    tooltip: string;
    auto: string;
    english: string;
    dutch: string;
  };
  consumerKey: string;
  consumerSecret: string;
  translatingMessage: string;
  selectTheLanguageOfTheMessage: string;
  messageTranslatedSuccessfully: string;

  atsConnectedSuccessfully: (ats: string) => string;
  weAreConnectingToYourATS: string;
  atsCandidateStatusChanged: string;
  atsNoteAdded: string;
  atsEmailSent: string;
  noCreditsAvailable: string;
  selectAProject: string;
  emailOrPhone: string;
  candidateSuccessfullyShortlistedToAnotherSearch: string;

  noCreditsAvailableForMonsterboardTitle: string;
  noCreditsAvailableForMonsterboardDescription: () => React.ReactNode;
  errorRetrievingDepartments: string;
  noDepartmentsFound: string;
  activateBeforeSearchDepartments: string;
  candidateAlreadyInteracted: string;
  candidateAlreadyLinkedToAnotherMatch: string;
  newVersionAvailable: string;
  newVersionAvailableDescription: () => React.ReactNode;
  indeedSessionOutdated: string;
  indeedSessionOutdatedDescription: (onLinkClick?: () => void) => React.ReactNode;
  continue: string;
  languageSelection: string;
  googleTranslateMessage: () => React.ReactNode;
  maxAsteriskReached: string;
  maxAsteriskReachedModalDescription: string;
  maxAsteriskReachedModalClickHere: (params: { href: string }) => React.ReactNode;
  hideCandidatesThat: string;
  forPeriodOf: string;
  aiSuggestions: string;
  searchInputPlaceholder: string;
  findCandidates: string;
  lastSearches: string;
  noSearchesFound: string;
  didntFindJobTitleLocation: string;
  robinYearWrapped: (params: { year: number }) => string;
  robinWrapped: string;
  downloadYearWrapped: (params: { year: number }) => string;
  wrappedYear: (params: { year: number }) => string;
  wrappedSummary: (params: { tenantName: string }) => string;
  matchedInYear: (params: { year: number }) => string;
  shortlistedInYear: (params: { year: number }) => string;
  contactedInYear: (params: { year: number }) => string;
  topJobboard: string;
  mostActiveUser: string;
  totalAction: string;
  lengthLimitReached: string;
  getConnectedInstantly: string;
  downloadOurMobileApp: string;
  downloadOurMobileAppDescription: string;
  yourCallIsJustATapAway: string;
  checkYourPhoneForADirectCall: string;
  downloadRobinMobileApp: string;
  selectYourDevicePlatform: string;
  tapToCallCandidate: (candidateName: string) => string;
  youCanCopyTheLinkPressingCtrlC: string;
  info: string;
  success: string;
  error: string;
  warning: string;
  communicationChannelsWarning: string;
  welcomeBack: string;

  dashboard: string;

  summary: string;
  summaryOfActions: string;
  addSummary: string;
  removeSummary: string;
  allUsers: string;
  allCampaigns: string;

  overviewOfActions: string;
  onlyLastThreeMonths: string;

  leaderboard: string;
  summaryOfActivityForUsers: string;
  mostUsedJobboardsForMatched: (method: string) => string;
  allActions: string;
  campaignCreated: string;
  campaignListEmptyStateMessage: string;

  exportInPDF: string;
  noMoreResults: string;
  usersSelected: string;
  campaignsSelected: string;
  clickHereToLoginBackIn: string;
  loginSuccessfully: string;
  browserExtensionIsDisabledOrNotInstalled: string;
  clickHereToRefreshThisPage: string;
  toDisconnectClickTheButton: string;

  shouldInstallBrowserExtensionTitle: string;
  shouldInstallBrowserExtensionModal: React.ReactNode;
  shouldCallWerknlOutreachTitle: string;
  shouldCallWerknlOutreachModal: React.ReactNode;
  shouldCallWerknlOutreachDoesntSatisfyAuthorizationTitle: string;
  shouldCallWerknlOutreachDoesntSatisfyAuthorizationModal: string;
  shouldCallWerknlOutreachAuthorizationExpiredTitle: string;
  shouldCallWerknlOutreachAuthorizationExpiredModal: string;

  linkedinRunOutCreditsMessage: string;
  linkedinRunOutCreditsSendMessage: string;
  linkedinRunOutCreditsSendingMessage: (params: { onClick: () => void }) => React.ReactNode;
  werknlMessageTo: (name: string) => string;
  werknlInputEmail: string;
  werknlInputPhone: string;

  settings: string;
  emailSettings: string;
  schedulerEditor: string;
  connectEmailAccount: string;
  reconnectEmailAccount: string;
  theConnectionWasASuccess: string;
  theConnectionWasASuccessDescription: string;
  theConnectionFailed: string;
  theConnectionFailedDescription: string;
  backToRobin: string;
  disconnectEmailAccount: string;
  emailNotConnectedDescription: React.ReactNode;
  emailConnectedDescription: string;
  emailConnections: string;
  sharedCalendarSettings: string;
  availableTimes: string;
  meetingEventTitle: string;
  meetingDuration: string;
  bookingInterval: string;
  availableDays: string;
  timezone: string;
  sharedCalendars: string;
  sharedCalendarsDescription: string;
  sharedCalendarsSelectedCount: (selected: number, max: number) => string;
  sharedCalendarsLimitReached: string;
  calendarConnected: string;
  calendarNotConnected: string;
  minutesShort: (minutes: number) => string;
  hoursShort: (hours: number) => string;
  daysShort: (days: number) => string;
  workingDaysShort: (days: number) => string;
  invalidTimeRange: string;
  bookingWindow: string;
  bookingWindowDescription: string;
  bookingWindowMin: string;
  bookingWindowMinHelp: string;
  bookingWindowMinTooltip: string;
  bookingWindowWorkingDays: string;
  bookingWindowWorkingDaysTooltip: string;
  bookingWindowMax: string;
  bookingWindowMaxHelp: string;
  bookingWindowMaxTooltip: string;
  bookingWindowNoLimit: string;
  noUsersAvailable: string;
  bookingPool: string;
  bookingPoolName: string;
  bookingPoolNamePlaceholder: string;
  bookingPoolNameRequired: string;
  addBookingPool: string;
  createBookingPool: string;
  noBookingPoolsDescription: string;
  bookingPoolNoLongerAvailable: string;
  intakeScheduling: string;
  intakeSchedulingDescription: string;
  intakeSchedulingNoPools: string;
  intakeStepInterview: string;
  liveOnboardingTitle: string;
  liveOnboardingDescription: string;
  liveOnboardingNoCities: string;
  liveOnboardingAddCity: string;
  liveOnboardingNewCity: string;
  liveOnboardingPlacesCount: (count: number) => string;
  liveOnboardingNoTimesSet: string;
  liveOnboardingPaused: string;
  liveOnboardingFieldCity: string;
  liveOnboardingFieldCityHelp: string;
  liveOnboardingFieldName: string;
  liveOnboardingFieldNameHelp: string;
  liveOnboardingFieldLocationName: string;
  liveOnboardingFieldLocationNameHelp: string;
  liveOnboardingFieldLocationAddress: string;
  liveOnboardingFieldLocationAddressHelp: string;
  liveOnboardingFieldDefaultCapacity: string;
  liveOnboardingFieldMinWorkingDays: string;
  liveOnboardingNoticeSameDay: string;
  liveOnboardingFieldCutoffTime: string;
  liveOnboardingCutoffNever: string;
  liveOnboardingFieldMaxDays: string;
  liveOnboardingFieldRescheduleWindow: string;
  liveOnboardingFieldRescheduleWindowHelp: string;
  liveOnboardingRescheduleUntilStart: string;
  liveOnboardingFieldReminder: string;
  liveOnboardingReminderNone: string;
  liveOnboardingReminderHour: string;
  liveOnboardingReminderFourHours: string;
  liveOnboardingReminderDay: string;
  liveOnboardingReminderTwoDays: string;
  liveOnboardingFieldCalendar: string;
  liveOnboardingCalendarNone: string;
  liveOnboardingCalendarShared: string;
  liveOnboardingCalendarsEmpty: string;
  liveOnboardingBookingRules: (workingDays: number, cutoff: string) => string;
  liveOnboardingBookingRulesNoCutoff: (workingDays: number) => string;
  liveOnboardingWorkingDaysNote: string;
  liveOnboardingCityTaken: string;
  liveOnboardingGridTitle: string;
  liveOnboardingAddTime: string;
  liveOnboardingFieldDuration: string;
  liveOnboardingCapacityDefault: (count: number) => string;
  liveOnboardingCapacityNote: string;
  liveOnboardingRemoveTime: string;
  liveOnboardingRestoreTime: string;
  liveOnboardingTimeOff: string;
  liveOnboardingOffTimeNote: string;
  liveOnboardingRecurrenceTaken: string;
  liveOnboardingTimetableFailed: string;
  liveOnboardingSessionsTitle: string;
  liveOnboardingSessionsEmpty: string;
  liveOnboardingSessionsTimezoneNote: (timezone: string) => string;
  liveOnboardingSessionPlaces: (taken: number, capacity: number) => string;
  liveOnboardingSessionFull: string;
  liveOnboardingSessionCancelled: (reason: string | null) => string;
  liveOnboardingWhosComing: string;
  liveOnboardingAttendeesEmpty: string;
  liveOnboardingCancelSession: string;
  liveOnboardingCancelTitle: string;
  liveOnboardingCancelBodyEmpty: string;
  liveOnboardingCancelBody: (count: number) => string;
  liveOnboardingCancelReason: string;
  liveOnboardingCancelReasonHelp: string;
  liveOnboardingCancelConfirm: string;
  liveOnboardingCancelKeep: string;
  liveOnboardingSessionAlreadyCancelled: string;
  notSet: string;
  screeningMethodHumanUnavailable: string;
  screeningMethodAiUnavailable: string;
  paginationPageOf: (current: number, total: number) => string;
  disconnectEmailAccountModalDescription: string;
  connectEmailModalDescription: string;
  connectEmailDescription: React.ReactNode;
  connectYourEmailToContinue: string;
  shouldConnectEmailDialogDescription: React.ReactNode;
  emailConnected: string;
  yourEmailIsConnectedAndReadyToUse: string;
  ok: string;
  verifyingConnection: string;
  verifyConnection: string;
  tryAgain: string;
  pleaseWaitWhileWeVerifyYourEmailConnection: string;
  errorWhileConnectingEmail: string;
  errorWhileConnectingEmailDescription: string;
  emailCopiedCandidateMarkedAsContacted: string;
  remindToConnectEmail: (name: string) => React.ReactNode;
  remindToReconnectEmail: (name: string) => React.ReactNode;
  werknlProfiles: string;
  waitForTheCampaignToFullyLoad: string;
  werknlIsCurrentlyDisabled: string;
  loadingCandidateCv: string;
  noShortlistedCandidate: (params: { onClick: () => void }) => React.ReactNode;
  noOtherStatusCandidate: (status: string) => string;
  werknlCandidateInfoPresentation: React.ReactNode;
  werknlCandidateInfoPresentationDescription: string;
  werknlCandidateInfoPresentationNote: string;
  old: string;
  confirmSelection: string;
  werknlLayout: string;
  cvFormatIssues: string;
  disconnectVacancy: string;
  clickToActivatePlatform: (name: string) => string;
  fromTo: (from: string, to: string) => string;
  from: string;
  newCandidateAdded: string;
  for: string;
  called: string;
  confirmDeleteNote: string;
  robinResume: string;
  robinResumeDescription: (atsName?: string) => React.ReactNode;
  confirmStatus: string;
  statusSavedWithSuccess: string;
  syncingYourAtsStatuses: string;
  statusConfirmed: string;
  statusesRefreshed: string;
  checkCandidateStatuses: string;
  readMore: string;
  loginToIndeed: string;
  indeedAssignedMessageInfo: (email: ReactNode) => ReactNode;
  indeedUnassignedMessageInfo: ReactNode;
  indeedLicenseRequired: ReactNode;
  indeedLicense: string;
  isAdmin: string;
  indeedLicensesCanBeAssigned: string;
  indeedSubscriptionConnectedTitle: string;
  indeedSubscriptionConnectedDescription: (email: string) => React.ReactNode;
  noIndeedSubscriptionConnectedTitle: string;
  noIndeedSubscriptionConnectedDescription: React.ReactNode;
  indeedSubscriptionAvailableTitle: string;
  indeedSubscriptionAvailableDescription: (emails: string[]) => React.ReactNode;
  noIndeedSubscriptionAvailableTitle: string;
  noIndeedSubscriptionAvailableDescription: React.ReactNode;
  indeedSubscriptionGrantedTitle: string;
  indeedSubscriptionGrantedDescription: (email: string) => React.ReactNode;
  indeedSubscriptionWithdrawnTitle: string;
  indeedSubscriptionWithdrawnDescription: (email: string) => React.ReactNode;
  indeedSubscriptionWithdrawnSubscriptionAvailableTitle: string;
  indeedSubscriptionWithdrawnSubscriptionAvailableDescription: (email: string, emails: string[]) => React.ReactNode;
  indeedSubscriptionExpiredWithAvailableTitle: string;
  indeedSubscriptionExpiredWithAvailableDescription: (emails: string[]) => React.ReactNode;
  indeedSubscriptionExpiredTitle: string;
  indeedSubscriptionExpiredDescription: React.ReactNode;
  indeedSubscriptionConnectedAdminTitle: string;
  indeedSubscriptionConnectedAdminDescription: (email: string) => React.ReactNode;
  noIndeedSubscriptionConnectedAdminTitle: string;
  noIndeedSubscriptionConnectedAdminDescription: React.ReactNode;
  noIndeedActiveSubscriptionWithAvailableTitle: string;
  noIndeedActiveSubscriptionWithAvailableDescription: (email: string, emails: string[]) => React.ReactNode;
  noIndeedActiveSubscriptionTitle: string;
  noIndeedActiveSubscriptionDescription: (email: string) => React.ReactNode;
  unassignLicense: string;
  statusNeedToBeConfirmedForThisTenant: string;
  robinResumeDashboardDescription: string;
  totalNumberOfCvs: string;
  startsWith: string;
  contains: string;
  endsWith: string;
  selectAnAtsVacancy: string;
  selectJobImprovedModalSubtitle: string;
  selectJobModalInsufficientJobInfo: string;
  selectJobModalIntroMessage: ReactNode;
  selectAtsVacancyFirst: (candidateFirstName: string, atsName: string) => string;
  selectAtsVacancyRobinJr: (candidateFirstName: string, atsName: string) => string;
  selectAtsVacancyForMatching: (candidateFirstName: string, atsName: string) => string;
  skipAndMatch: string;
  matchAndPushToAts: string;
  skipAndSendMessage: string;
  sendAndPushToAts: string;
  selectAtsVacancyForScheduling: (candidateFirstName: string, atsName: string) => string;
  skipAndSchedule: string;
  connectAndSchedule: string;
  theCandidate: string;
  yourAts: string;
  insufficientInfoRobinJr: string;
  enabledRobinJrFollowUpTitle: string;
  enabledRobinJrFollowUpDescription: string;
  disableRobinJrFollowUpTitle: string;
  disableRobinJrFollowUpDescription: string;
  yesCancelIt: string;
  candidateContactedViaEmail: string;
  read: string;
  indeedAttemptRetrying: string;
  indeedAttemptsCount: (attemptsCount: number) => string;
  indeedAttemptNotDelivered: string;
  indeedAttemptNotSent: string;
  indeedAttemptDelivered: string;
  indeedFailureAlreadyContacted: (candidateName: string) => string;
  indeedFailureRecentlyDeclined: (candidateName: string) => string;
  indeedFailureSubscriptionMismatch: string;
  indeedFailureGeneric: string;
  indeedFailureLastTried: (timeAgo: string) => string;
  indeedFailureRetry: string;
  indeedFailureRetrying: string;
  emailFollowUpPlanned: string;
  cancelFollowUp: string;
  robinJr: string;
  boostReplies: string;
  letsTryIt: string;
  reachoutConversion: string;
  conversionOfAllChannels: string;
  conversations: string;
  conversion: string;
  weAreGeneratingAiMessage: string;
  candidatesContacted: string;
  responded: string;
  replied: string;
  manualReachOut: string;
  aiReachOut: string;
  addJob: string;
  editCustomJob: string;
  disconnectJob: string;
  callOutcome: string;
  selectLabel: string;
  theLabelSelectionIsRequired: string;

  // Central Inbox
  inbox: string;
  emptyConversations: string;
  addNote: string;
  takeNote: string;
  all: string;
  unread: string;
  sent: string;
  openInInbox: string;
  switchAnyway: string;
  stayOnCurrentChannel: string;
  switchChannelsTitle: string;
  switchChannelsContent: string;
  inboxEmailConnected: string;
  inboxEmailDisconnected: string;
  inboxWhatsappConnected: string;
  inboxWhatsappDisconnected: string;
  inboxLinkedinConnected: string;
  inboxLinkedinDisconnected: string;
  inboxLinkedinInmailConnected: string;
  inboxLinkedinInmailDisconnected: string;
  inboxIndeedConnected: string;
  inboxIndeedDisconnected: string;
  inboxRjCommunicationHubConnected: string;
  inboxRjCommunicationHubDisconnected: string;

  // vacancy creation/enriching
  removeEnrichedVersion: string;
  atsNotConnected: string;
  atsNotConnectedDescription: React.ReactNode;
  manageYourJobs: string;
  checkInfo: string;
  createNewJob: string;
  atsVersion: string;
  enrichedVersion: string;
  jobPreview: string;
  jobDetails: string;
  viewOnIndeed: string;
  visibleToCandidatesAsAttachment: string;
  theJobPreviewHasBeenCopied: string;
  updatingJobPreview: string;
  applicationDeadline: string;
  salaryUnit: string;
  workingHoursRange: string;
  workdays: string;
  shifts: string;
  workAddress: string;
  radiusKm: string;
  positionOverview: string;
  jobRequirements: string;
  minimumEducationLevel: string;
  driversLicense: string;
  tasks: string;
  keyTasks: string;
  secondaryBenefits: string;
  goodStatus: string;
  hourly: string;
  monthly: string;
  weekly: string;
  yearly: string;
  allWorkDays: string;
  monday: string;
  tuesday: string;
  wednesday: string;
  thursday: string;
  friday: string;
  saturday: string;
  sunday: string;
  shiftDay: string;
  shiftEvening: string;
  shiftNight: string;
  shift2Cycle: string;
  shift3Cycle: string;
  shift4Cycle: string;
  shift5Cycle: string;
  thinking: string;
  improveWithAI: string;
  languagesLabel: string;
  employmentRequirements: string;
  level: string;
  saveAndSubmit: string;
  reviewingYourVacancyForQuality: string;
  fullTime: string;
  partTime: string;
  thisFieldIsRequiredError: string;
  pleaseSelectAValidLocation: string;
  editVacancy: string;
  enrichVacancy: string;
  insufficientInfo: string;
  addDetailsOrSelectAnotherJob: string;
  lowReplyChance: string;
  mediumReplyChance: string;
  highReplyChance: string;
  sufficientInfo: string;
  letsImproveIt: string;
  createAJob: string;
  enrichVacancyChooseMethod: string;
  provideText: string;
  selectTemplate: string;
  uploadFile: string;
  jobDescription: string;
  robinJrSuggestions: string;
  insert: string;
  atsContentWarning: string;
  lowQuality: string;
  mediumQuality: string;
  highQuality: string;
  noVacanciesFound: string;
  checkYourAtsConnection: string;
  learnMore: string;
  learnMoreLink: string;
  youCanAlso: string;
  inRobin: string;
  removeEnrichedVersionDescription: string;
  yesRemoveIt: string;
  theAtsContentHasBeenCopied: string;
  theIndeedContentHasBeenCopied: string;
  errorProcessingVacancyFile: React.ReactNode;
  atsDisconnected: string;
  addDetailsAndIncreaseYourChanceToGetAReply: ReactNode;
  jobDescriptionComplete: ReactNode;
  improveGeneratedMessage: string;
  couldNotCreateMessageDueToInsufficientData: string;
  messageGeneratedButCouldBeStronger: string;
  // vacancy creation/enriching placeholders form
  minimumEducationLevelPlaceholder: string;
  languagesPlaceholder: string;
  address: string;
  workAddressPlaceholder: string;
  phonePlaceholder: string;
  salaryRangePlaceholder: string;
  salaryRangePlaceholderMax: string;
  workingHoursRangePlaceholder: string;
  shiftPlaceholder: string;
  workdaysPlaceholder: string;
  certificationsPlaceholder: string;
  matchedByColleague: string;
  contactedByColleague: string;
  hiddenByMe: string;

  commuteByCar: string;
  commyteByBike: string;
  bestMatch: string;

  checkYourPhone: string;
  phoneNotConnected: string;
  connectYourMobileToRobin: string;
  connectYourMobileToRobinDescription: React.ReactNode;
  gotIt: string;

  alwaysShowAlternativeChannels: string;
  alternativeChannels: string;
  alternativeChannelsDescription: string;
  dontShowThisNextTime: string;
  sendWhatsApp: string;
  sendWerknl: string;
  sendLinkedin: string;
  sendIndeed: string;
  connectWithCandidateLinkedin: (candidateName: string) => string;
  messageCandidateLinkedin: (candidateName: string) => string;
  indeedJob: string;
  indeedJobs: string;
  atsJobs: string;

  // Added by AI
  processing: string;
  processJob: string;

  minWorkingHours: string;
  maxWorkingHours: string;
  minWorkingHoursPlaceholder: string;
  maxWorkingHoursPlaceholder: string;

  employmentTypeTemporaryAgencyWork: string;

  /* ---- start: added by AI ---- */
  activateRobinJrTitle: string;
  activateRobinJrDescription: React.ReactNode;
  activateRobinJrIndeedDescription: React.ReactNode;
  reactivateRobinJrTitle: React.ReactNode;
  reactivateRobinJrDescription: React.ReactNode;
  activateRobinJrTrackProgress: string;
  getStarted: string;
  robinJrIsAnalysingYourVacancy: string;
  startingRobinJr: string;
  confirmAndStart: string;
  confirmAndNext: string;
  sendIndeedMessage: string;
  indeedCreditsRemainingPrefix: string;
  indeedCreditsLabel: (credits: number) => string;
  indeedCreditsRemainingSuffix: string;
  indeedJobNotHighQuality: string;
  editAndEnhanceJob: string;
  toActivateRobinJr: string;
  reviewQualificationQuestionary: string;
  pleaseReviewTheQualificationQuestions: string;
  jobUpdatedReviewRequired: React.ReactNode;
  loadingQualificationQuestionary: React.ReactNode;
  reviewOutreachMessage: string;
  autoSendInterviewInviteTitle: string;
  autoSendInterviewInvite: React.ReactNode;
  dontShowQualificationQuestionaryPreviewNextTime: React.ReactNode;
  reviewOutreachMessageDescription: string;
  robinJrBulkPersonalisingReviewBeforeSend: string;
  robinJrBulkReachingOutToEachCandidate: string;
  checkRobinBoxForReplies: string;
  checkRobinBox: string;
  confirmRemoveBulkCandidate: (name: string) => string;
  sendingMessages: string;
  bulkAllMessagesSent: string;
  bulkSomeMessagesCouldNotBeSent: string;
  sentProgress: (sent: number, total: number) => string;
  previewAsCandidate: string;
  regenerateMessage: string;
  bulkGenerating: string;
  bulkAllMessagesReady: string;
  bulkAllMessagesReadyReviewBeforeSend: string;
  bulkSomeMessagesCouldNotBeGeneratedReviewBeforeSend: string;
  bulkNFailed: (n: number) => string;
  bulkGenerationDoneWithFailures: (n: number) => string;
  bulkSending: string;
  bulkSendingDoneWithFailures: (n: number) => string;
  bulkSendingReachingOut: (name: string) => string;
  bulkSendingFailure: (name: string) => string;
  bulkIndeedWaitingForReply: string;
  bulkIndeedSendingFailure: (name: string) => string;
  bulkIndeedCheckSession: string;
  dontShowMessagePreviewNextTime: string;
  dontShowWhatsappMessagePreviewNextTime: string;
  changingTheJobWillRestart: string;
  areYouSureToPauseRobinJr: string;
  robinJrIsCurrentlyDescription: (currentAction: string) => React.ReactNode;
  robinJrIndeedPauseDescription: React.ReactNode;
  yesStopIt: string;
  communicationEnded: string;
  reachingOutCandidate: string;
  rjCommHubIndeedWaitingForReply: string;
  rjCommHubIndeedWaitingForEmailAddress: string;
  sentFirstFollowUp: string;
  sentSecondFollowUp: string;
  robinJrActive: string;
  goodNewsCandidate: (candidateName: string, jobTitle: string, vefiedInfo?: ReactNode) => ReactNode;
  candidateNotInterested: (candidateName: string, jobTitle: string) => React.ReactNode;
  didntReceiveResponse: string;
  companyIsHiring: (params: { jobTitle?: string; salaryRange?: string; city?: string }) => string;
  loadingVacancyDetails: string;
  vacancyPreviewUnavailable: string;
  vacancyPreviewError: string;
  errorLoadingVacancy: (error: string) => string;
  vacancyNotFound: string;
  aboutTheRole: string;
  yourResponsibilities: string;
  whatWeOffer: string;
  certificatesLabel: string;
  driversLicenseLabel: string;
  interestedInOpportunity: string;
  yesPlease: string;
  noThanks: string;
  questionsEmailUs: string;
  poweredBy: string;
  emailFooterDoNotReply: string;
  emailFooterRobinProcesses: string;
  emailFooterUnsubscribe: string;
  emailFooterPrivacyPolicy: string;
  robinJrBrandingTitle: string;
  robinJrBrandingSubtitle: string;
  robinJrBrandingUploadLogo: string;
  robinJrBrandingUploadHint: string;
  robinJrBrandingUploadMaxSize: string;
  robinJrBrandingSelectColorFromScreen: string;
  robinJrBrandingSaveTemplate: string;
  robinJrBrandingSaving: string;
  robinJrBrandingShowPreview: string;
  robinJrBrandingPleaseUploadLogo: string;
  robinJrBrandingInvalidFileType: string;
  robinJrBrandingFileTooLarge: string;
  robinJrBrandingSavedSuccessfully: string;
  robinJrBrandingSaveFailed: string;
  robinJrBrandingOrganisation: string;
  robinJrBrandingLoadFailed: string;
  robinJrBrandingDefaultBadge: string;
  robinJrBrandingSetAsDefault: string;
  robinJrBrandingSetAsDefaultSuccess: string;
  robinJrBrandingSetAsDefaultFailed: string;
  robinJrBrandingEyedropperNotSupported: string;
  robinJrBrandingReset: string;
  robinJrBrandingResetting: string;
  robinJrBrandingResetConfirmTitle: string;
  robinJrBrandingResetConfirmDescription: string;
  robinJrBrandingResetSuccessfully: string;
  robinJrBrandingResetFailed: string;
  cantUseRobinJrUnsubscribed: React.ReactNode;
  clickToActivateRobinJr: string;
  indeedNoVacancySelected: string;
  thanksForYourInterest: string;
  thanksForYourResponse: string;
  recruiterWillReachOutSoon: string;
  strictlyRequiredForThisJob: string;
  byConfirmingYouAgreeToShare: string;
  anyFeedbackOptional: string;
  helpUsImproveJobRecommendations: string;
  weUnderstandThanks: string;
  noMoreJobAlertsFromUs: string;
  recruiterWillReachOutSoonConfirmation: string;
  viewVacancy: string;
  noVacancyAnymore: string;
  rjCommHubWhatsAppMessage: (params: {
    candidateFirstName: string;
    recruiterFirstName: string;
    companyName: string;
    jobBoardName: string;
    vacancyName: string;
    vacancyLocation: string;
    vacancySalary: string;
    vacancyShift: string;
    includeEmailNote: boolean;
  }) => ReactNode;
  rjCommHubWhatsAppMessageString: (params: {
    candidateFirstName: string;
    recruiterFirstName: string;
    companyName: string;
    jobBoardName: string;
    vacancyName: string;
    vacancyLocation: string;
    vacancySalary: string;
    vacancyShift: string;
    includeEmailNote: boolean;
  }) => string;

  // Questionnaire Screen
  weNeedABitMoreInfo: string;
  someDetailsAreMissing: (jobBoard: string) => ReactNode;
  addingThemWillHelp: string;
  areYouCurrentlyOpenToWork: string;
  doYouHaveFollowingCertificates: string;
  doYouHaveAnyOtherCertificates: string;
  isThisIncomeAcceptableForYou: string;
  whatIsYourDesiredSalaryRange: string;
  thisJobOffersASalary: (amount: string, unit: string) => string;
  areYouAvailableForThisSchedule: string;
  doYouHaveAnyOtherShiftAvailable: string;
  whatAreYouAvailableDays: string;
  areYouComfortableWithTheseRequirements: string;
  areYouAbleToPerformTheseSpecificJobTasks: string;
  pleaseTellUsAboutAnyLimitationsOrPreferences: string;
  areThereAnyOtherTasksYouCanDo: string;
  requiresWorkingHours: (hours: string, unit: string) => string;
  howManyHoursPerWeekWouldYouLikeToWork: (unit: string) => string;
  doTheseHoursPerWeekWorkForYou: string;
  doYouSpeakTheseLanguages: string;
  whichLanguagesDoYouSpeak: string;
  submitAndUpdateInfo: string;
  byConfirming: string;
  typeAndPressEnterToAdd: string;
  to: string;
  couldNotGenerateEnrichedVacancy: string;
  couldNotGenerateJobPreview: string;
  previewInIndeed: string;
  previewInIndeedModalTitle: string;
  previewInIndeedModalDescription: string;
  backToJobPreview: string;
  backToEditor: string;
  addMore: string;
  daily: string;
  week: string;
  day: string;
  hour: string;
  workShiftAvailability: string;
  certificationsLicenses: string;
  languagesSpoken: string;
  yourProfileHasBeenUpdated: string;
  yourInformationIsNowComplete: string;
  questionnaireCompleteTitle: string;
  questionnaireCompleteMessage: string;
  jobAlertsActivated: string;
  wellKeepYouUpdatedWithMoreJobOpportunities: string;
  jobNotificationsEnabledTitle: string;
  jobNotificationsEnabledDescription: string;
  youllHearFromUs: string;
  wellReachOutWhenAJobMatchesYourProfile: string;
  confirmUnsubscribeTitle: string;
  confirmUnsubscribeDescription: string;
  confirmUnsubscribe: string;
  confirmUnsubscribeFooterText: string;
  updateYourProfile: string;
  keepYourInformationUpToDate: string;
  saveProfile: string;
  interviewWithRecruiterFromCompany: (recruiterFirstName: string, companyName: string) => string;

  syncing: string;
  syncingSuccessfully: string;
  syncingFailed: string;
  noMessagesFound: string;
  whoAreYouHiringToday: string;
  jobPreviewIsAvailable: string;
  jobTitleAndStatus: (jobTitle: string, status: string) => string;
  working_hours_per_week: string;
  available_days: string;
  readyForJobOffersLabel: string;
  travel_time: string;
  transportation: string;
  reachedOutQuestion: string;
  reachedOutQuestionDescription: string;
  noNotYet: string;
  yesMarkAsContacted: string;
  detachJob: string;
  toChangeYourEmailPleaseEnterYourPassword: string;

  candidateIsMovedTo: (candidateName: string, status: string) => string;

  checked: string;
  checkedCandidateInfoAt: (lastVerifiedAt: string) => ReactNode;
  checkedPreferencesAt: (lastVerifiedAt: string) => ReactNode;
  checkedAvailabilityAt: (lastVerifiedAt: string) => ReactNode;
  hideCandidateFeedbackTitle: string;
  hideCandidateFeedbackDescription: string;
  hideCandidateFeedbackReasonIrrelevantExperience: string;
  hideCandidateFeedbackReasonMismatchedPreferences: string;
  hideCandidateFeedbackReasonLocation: string;
  hideCandidateFeedbackReasonQualifications: string;
  hideCandidateFeedbackReasonLowQuality: string;
  hideCandidateFeedbackDetailsPlaceholder: string;
  discardChangesModalTitle: string;
  discardChangesModalDescription: string;
  keepEditing: string;
  discardChanges: string;

  messagesPulledSuccessfully: string;
  lastJobboardMessage: (jobboard: string) => string;
  messagesPulledFailed: string;
  messagesSynced: string;
  messagesNotSynced: string;
  clickResyncToTryAgainOrReachOutToSupport: string;
  lastSynced: string;
  resync: string;
  statusesDropdownLabel: string;
  refreshStatuses: string;
  youAreNotAllowedToRefreshStatusesToday: string;

  viewFullJobDetails: string;
  noCandidatesFound: string;
  keyResponsabilities: string;
  salaryRange: string;
  languageLevel: string;
  chooseAFileOrDragAndDrop: string;
  uploadFileToGetStarted: string;
  creatingChatFrom: (source: string) => string;
  matchRate: string;
  whoIsRobinJr: string;
  howCanIConnectMyAts: string;
  canIUploadAFile: string;
  messageSentTo: (name: string) => string;
  searchOrCreateLabel: string;
  selectCallOutcome: string;
  copiedToClipboard: string;
  emailNotAvaialbe: string;
  enterCandidateEmail: string;
  scheduleInterviewNow: string;
  pleaseGrantAccessToYourCalendar: string;
  pleaseConnectYourEmailToUseInterviewScheduler: string;
  schedulerInviteSubject: string;
  schedulerInviteMessage: string;
  schedulerLinkText: string;
  theFollowingFieldsAreRequired: string;
  currentStatus: string;
  whatTypeOfInterviewWouldYouLikeToSchedule: string;
  setupInterview: string;
  dontShowSetupInterviewAgain: string;
  youCanManageEmailSettings: React.ReactNode;
  typeToSearchForAnAddress: string;
  matchInsights: string;
  checkedPreferences: string;
  seeMatchedCandidates: string;
  searchButtonIsReady: string;
  /* ---- end: added by AI ---- */

  writeWithAi: string;
  writingCustomizedMessage: string;
  nylasCalendarConnectionModalTitle: string;
  nylasCalendarConnectionModalDescription: ReactNode;
  nylasCalendarConnectionModalConnectCalendar: string;
  nylasCalendarConnectionModalCalendarSetUpTitle: string;
  nylasCalendarConnectionModalCalendarSetUpText: string;
  nylasCalendarStatusValid: string;
  nylasCalendarStatusInvalid: string;
  nylasCalendarStatusNotConnected: string;
  nylasCalendarStatusError: string;
  nylasCalendarStatusUnknown: string;
  goToEmailSettings: string;
  maybeLater: string;
  videoInterviewAboutTheVacancy: string;
  introductionAtTheLocation: string;
  telephoneConversationAboutTheVacancy: string;
  onlineInterview: string;
  inPersonInterview: string;
  callInterview: string;
  role: string;
  weFoundSomeGreatMatchesForYou: string;
  failedToLoadJobRecommendations: string;
  interviewFeedbackTitle: string;
  interviewFeedbackSubtitleFallback: string;
  interviewFeedbackSubtitleCandidateFull: (name: string, jobTitle: string) => string;
  interviewFeedbackSubtitleCandidateName: (name: string) => string;
  interviewFeedbackSubtitleRecruiterFull: (name: string, jobTitle: string) => string;
  interviewFeedbackSubtitleRecruiterName: (name: string) => string;
  interviewFeedbackTagsLabelHigh: string;
  interviewFeedbackTagsLabelLow: string;
  interviewFeedbackCommentLabelHigh: string;
  interviewFeedbackCommentLabelLow: string;
  interviewFeedbackCommentPlaceholder: string;
  interviewFeedbackSubmit: string;
  interviewFeedbackThankYouTitle: string;
  interviewFeedbackThankYouHigh: string;
  interviewFeedbackThankYouLowTitle: string;
  interviewFeedbackThankYouLow: string;
  interviewFeedbackReviewTitle: string;
  interviewFeedbackReviewBody: string;
  interviewFeedbackReviewButton: string;
  interviewFeedbackInvalidTitle: string;
  interviewFeedbackInvalidBody: string;
  interviewFeedbackTagCommunication: string;
  interviewFeedbackTagScheduling: string;
  interviewFeedbackTagClarity: string;
  interviewFeedbackTagSpeed: string;
  interviewFeedbackTagInterviewer: string;
  interviewFeedbackTagOverall: string;
  screeningSubmit: string;
  screeningSubmitting: string;
  screeningLoading: string;
  screeningRetry: string;
  screeningSubmitError: string;
  screeningPassedTitle: string;
  screeningPassedBody: string;
  screeningNeutralTitle: string;
  screeningNeutralBody: string;
  screeningInvalidTitle: string;
  screeningInvalidBody: string;
  screeningErrorTitle: string;
  screeningErrorBody: string;
  screeningMethodTitle: string;
  screeningMethodHumanLabel: string;
  screeningMethodHumanBody: string;
  screeningMethodAiLabel: string;
  screeningMethodAiBody: string;
  screeningMethodFinalNote: string;
  screeningMethodConfirm: string;
  screeningMethodError: string;
  screeningBookedTitle: string;
  screeningBookedBody: string;
  screeningOnboardingBookedTitle: string;
  screeningOnboardingBookedBody: string;
  applyOnboardingAppointmentLabel: string;
  applyOnboardingScheduleTitle: string;
  applyOnboardingScheduleBody: string;
  applyOnboardingFullTitle: string;
  applyOnboardingFullBody: string;
  applyOnboardingConfirmTitle: string;
  applyOnboardingConfirmBody: string;
  applyOnboardingConfirmCta: string;
  applyOnboardingFieldWhere: string;
  applyOnboardingAddToCalendar: string;
  applyOnboardingChangeUntilSoon: string;
  applyOnboardingSessionFull: string;
  applyOnboardingSessionClosed: string;
  applyOnboardingNotReschedulable: string;
  applyOnboardingBookError: string;
  screeningBookingOrganizer: string;
  screeningAiPendingTitle: string;
  // The two halves of waiting for an AI interview link. `Preparing` is what the poll shows;
  // `Pending` is what it says once it gives up, which is not an error — the same process that
  // builds the link also e-mails it.
  screeningAiPreparingBody: string;
  screeningAiPendingBody: string;
  screeningDisqualifiedTitle: string;
  screeningDisqualifiedBody: string;
  screeningDisqualifiedAnswerLabel: string;
  // The interview status screen: what the candidate has, then the ways to change it. The
  // order is the point — the action they came for is above the options, not below them.
  // Every string below is the UX prototype's own (`STR` in change-my-interview.html), key for
  // key, so this block can be diffed against it. Three deliberate departures, all decided:
  //
  // 1. Phone is out of scope, so the option subtitles drop their "video or phone" clauses and
  //    "change the time or how we talk" is just "change the time".
  // 2. The prototype's `carried` line is not here. It claims what the candidate already answered
  //    goes to the recruiter, and the backend confirmed nothing does.
  // 3. `addCal` is not here: there is no .ics endpoint.
  //
  // The not-yet-booked screen has no prototype equivalent — it is the arrival the mock does not
  // model — so its four strings are written in the same voice.
  applyInterviewTitle: string;
  applyInterviewRightNow: string;
  applyInterviewOptionsLabel: string;
  applyInterviewOptionHumanTitle: string;
  applyInterviewOptionHumanBody: string;
  applyInterviewOptionAiTitle: string;
  applyInterviewOptionAiBody: string;
  applyInterviewOptionRescheduleTitle: string;
  applyInterviewOptionRescheduleBody: string;
  applyInterviewFieldHow: string;
  applyInterviewHowVideo: string;
  // The candidate asked to be called instead. `applyInterviewHowPhone` is the `How` row's value;
  // the number is a row of its own, because a candidate checking their own number should not have
  // to read it out of a sentence.
  applyInterviewHowPhone: string;
  // The `Where` row beside `How`: the number on a phone call, and where the link arrives on a video
  // one. Two rows, because how the meeting happens and where to be for it are separate questions.
  applyInterviewFieldWhere: string;
  applyInterviewWhereVideo: string;
  // The callout under the channel picker. The lead is a sentence the number completes — "A recruiter
  // will call you on 06 12 34 56 78." — never a field label: we already hold the number, and the
  // candidate is confirming it rather than supplying it.
  applyChannelPhoneLead: string;
  applyChannelPhoneChange: string;
  applyChannelPhoneSave: string;
  // The server's verdict on a number it cannot dial, reworded in the candidate's own language. An
  // empty field needs no message — it holds Continue disabled, the way an unanswered question does.
  applyChannelPhoneInvalid: string;
  applyInterviewBack: string;
  // The candidate picked a recruiter, then closed the page before picking a time. No booking
  // to show and no deadline to state, so the screen says what is missing and offers both ways out.
  applyInterviewUnbookedTitle: string;
  applyInterviewUnbookedBody: string;
  applyInterviewUnbookedWhen: string;
  applyInterviewUnbookedWith: string;
  applyInterviewContinueCta: string;
  // The cut-off line under the options. Three cases, because `interview_method_change_closes_at`
  // is genuinely null on the AI path and on any pool counting its notice in working days.
  applyInterviewChangeUntilSubmit: string;
  applyInterviewChangeUntil: (when: string) => string;
  applyInterviewChangeUntilSoon: string;
  // Past the cut-off. Two different titles, not one: a call that is nearly here is still coming,
  // while a submitted interview is already with someone — and the second says so.
  applyInterviewClosedCallTitle: string;
  applyInterviewClosedCallBody: string;
  applyInterviewClosedAiTitle: string;
  applyInterviewClosedAiBody: string;
  // The calendar, opened to change something rather than to book for the first time.
  applyInterviewBookTitle: string;
  applyInterviewBookBody: string;
  // Every change ends on a confirmation, which is also a status screen: what they now have,
  // the thing to do next, and a way back.
  applyInterviewDoneBookedTitle: string;
  applyInterviewDoneMovedTitle: string;
  applyInterviewDoneAiTitle: string;
  applyInterviewDoneSub: (email: string) => string;
  applyInterviewDoneSubFallback: string;
  /**
   * What the AI interview actually asks and how long they have. It says nothing about the
   * call that was just cancelled, so it needs no email address and takes no argument.
   */
  applyInterviewDoneAiSub: string;
  applyInterviewChangeCta: string;
  // Switching to the AI-recruiter, the one direction that needs a confirmation: booking a slot
  // is the other switch, and by then the candidate has already seen what they are getting.
  applyInterviewAskAiTitle: string;
  applyInterviewAskAiBody: string;
  applyInterviewAskAiUnbookedBody: string;
  applyInterviewAskAiConfirm: string;
  // Not in the prototype, which never models a candidate giving up an AI interview. Confirming a
  // slot is what ends it, so the last screen before that is where it has to be said.
  applyInterviewSwitchNotice: string;
  changeInterviewError: string;
  changeInterviewAiUnavailable: string;
  changeInterviewAiFailed: string;
  changeInterviewAiFailedBooked: string;
  // Intake apply flow. Copy is B1 and informal ("je" in Dutch); no exclamation marks
  // anywhere, and uppercase is applied by CSS, never typed in.
  applyContinue: string;
  applyStepQuestions: string;
  applyStepMethod: string;
  applyStepSchedule: string;
  applyStepConfirm: string;
  applyStepCounter: (step: number, total: number) => string;
  applyQuestionCounter: (question: number, total: number) => string;
  applyReviewStepLabel: string;
  applyIntroGreeting: (name: string) => string;
  applyIntroGreetingGeneric: string;
  applyIntroBody: string;
  applyIntroAppliedFor: string;
  applyIntroExpectQuestionsTitle: (count: number) => string;
  applyIntroExpectQuestionsBody: string;
  applyIntroExpectMethodTitle: string;
  applyIntroExpectMethodBody: string;
  applyIntroExpectScheduleTitle: string;
  applyIntroExpectScheduleBody: string;
  applyIntroStart: string;
  applyIntroCheckNote: string;
  applyReviewTitle: string;
  applyReviewBody: string;
  applyReviewEdit: string;
  applyExitTitle: string;
  applyExitBody: string;
  applyExitReasonsLabel: string;
  applyExitClose: string;
  applyScheduleTitle: string;
  applyScheduleBody: string;
  /**
   * The apply flow's own wording for the slot-list heading and the generic booking flows'.
   *
   * The `interviewScheduling*` keys are shared with `features/interview-scheduling` and
   * `features/booking-reschedule`, which are not part of this tenant's apply flow. Where the
   * two want different words, the apply screens read an `apply*` key and the generic ones keep
   * theirs — that is what these next few exist for, and why they look like duplicates.
   */
  applySchedulePickTime: string;
  /**
   * Shown in place of the calendar when there is no time to pick — the listing is empty, or the pool
   * cannot take bookings. The address is the tenant's support inbox: candidates reach this flow
   * through channels they cannot reply to.
   */
  applyScheduleNoTimesTitle: string;
  applyScheduleNoTimesBody: (email: string) => string;
  applyConfirmTitle: string;
  applyConfirmBody: string;
  applyConfirmBooking: string;
  applyPickAnotherTime: string;
  /**
   * The wait while the times load, under the spinner where the calendar will be. The second line
   * arrives at 5 s and the third at 10 s — the listing can take that long when calendars are slow.
   */
  applySlotsLoading: string;
  applySlotsCheckingCalendars: string;
  applySlotsTakingLong: string;
  /**
   * The wait after the confirm click, in the button's own label. A booking can take over 10 s, so at
   * 10 s the label becomes `applySubmitStillConfirming` and `applySubmitDontClose` appears above it.
   */
  applyBookingSubmitting: string;
  applyRescheduleSubmitting: string;
  /** A switch between video and phone that keeps the time — nothing is moving, so not "Moving". */
  applyChannelChangeSubmitting: string;
  applySubmitStillConfirming: string;
  applySubmitDontClose: string;
  applyFieldRole: string;
  applyFieldAppointment: string;
  applyFieldTimezone: string;
  /** "Recruiter", where the AI screen's same row says "Met" — see `screeningBookingOrganizer`. */
  applyFieldRecruiter: string;
  applyFieldRecruiterEmail: string;
  applyBookedTitle: string;
  applyBookedSentTo: (email: string) => string;
  applyBookedSentToGeneric: string;
  applyBookedChangeTime: string;
  applyAiInterviewReadyTitle: string;
  applyAiInterviewReadyBody: string;
  applyAiInterviewWhen: string;
  applyAiInterviewPartner: string;
  applyAiInterviewStart: string;
  /**
   * The legal block under the AI interview. Marketing's wording, verbatim — the lead
   * sentence carries the human-review guarantee, the body the GDPR basis, so neither
   * may be paraphrased to fit.
   */
  applyAiLegalLead: string;
  applyAiLegalBody: string;
  /**
   * The accessibility route out of the AI interview. The address is written into the copy
   * because nothing in the screening payload carries a contact address.
   *
   * TODO: replace the hardcoded ubereats@adecco.nl with the tenant's support email once the
   * screening state carries one. Until then every tenant on this flow gets Uber Eats' mailbox.
   */
  applyAiLegalAccessibility: string;
  /**
   * The whole string, unlike `poweredBy`, which is only the prefix and takes the Robin
   * mark after it. This footer is text-only, so the name has to be in the copy.
   */

  /**
   * The post-interview landing screen — where the AI-interview vendor drops the candidate.
   *
   * The copy carries two standing constraints, both deliberate. **No timeline:** nothing in
   * the funnel commits to a response window, so it must not promise one, and "soon" is a
   * guess wearing a hat. **No outcome:** the tracker ends at Contact, not at a start date —
   * telling every candidate the job is theirs makes a rejection read as a broken promise.
   */
  intakeCompleteTitle: string;
  intakeCompleteBody: string;
  /** The line directly above the CTA, saying what My-Adecco is for. */
  intakeCompleteProfileNote: string;
  intakeCompleteCta: string;
  intakeTrackerApplied: string;
  intakeTrackerInterview: string;
  intakeTrackerReview: string;
  intakeTrackerContact: string;
  /** The tracker's accessible name. Re-read when the scooter lands on its stop. */
  intakeTrackerProgress: (step: number, total: number) => string;
  intakeFeedbackQuestion: string;
  /** Per-star accessible name, so the row is usable one star at a time. */
  intakeFeedbackStar: (stars: number) => string;
  intakeFeedbackGroupLabel: string;
  intakeFeedbackCommentPlaceholder: string;
  intakeFeedbackSend: string;
  /** Why Send is disabled. A rating is required; the comment alone is not a submission. */
  intakeFeedbackNeedsRating: string;
  intakeFeedbackThanksRating: string;
  intakeFeedbackThanksComment: string;
  /**
   * The feedback page's own card, at `/screening/:token/feedback` — where the star row in an intake
   * e-mail lands. It must not repeat the panel's question, which sits directly under it.
   */
  intakeFeedbackPageTitle: string;
  intakeFeedbackPageBody: string;

  interviewSchedulingTitle: string;
  interviewSchedulingGreeting: (name: string) => string;
  interviewSchedulingGreetingFallback: string;
  interviewSchedulingDuration: (minutes: number) => string;
  interviewSchedulingPickDate: string;
  interviewSchedulingPickTime: string;
  interviewSchedulingPickDayFirst: string;
  interviewSchedulingNoTimesInMonth: string;
  interviewSchedulingCheckNextMonth: string;
  interviewSchedulingTimezoneLabel: string;
  interviewSchedulingHostedFrom: (timezone: string) => string;
  interviewSchedulingBack: string;
  interviewSchedulingConfirmTitle: string;
  interviewSchedulingConfirmSubtitle: string;
  interviewSchedulingFieldWhen: string;
  interviewSchedulingFieldDuration: string;
  interviewSchedulingFieldName: string;
  interviewSchedulingFieldEmail: string;
  interviewSchedulingFieldOrganizer: string;
  interviewSchedulingFieldOrganizerEmail: string;
  interviewSchedulingConfirmButton: string;
  interviewSchedulingBookedTitle: string;
  interviewSchedulingBookedSubtitle: (email: string) => string;
  interviewSchedulingJoinMeeting: string;
  interviewSchedulingNoConferencing: string;
  interviewSchedulingSlotTakenTitle: string;
  interviewSchedulingSlotTakenBody: string;
  interviewSchedulingProviderDownTitle: string;
  interviewSchedulingProviderDownBody: string;
  interviewSchedulingRetry: string;
  interviewSchedulingInvalidTitle: string;
  interviewSchedulingInvalidBody: string;
  interviewSchedulingExpiredTitle: string;
  interviewSchedulingExpiredBody: string;
  interviewSchedulingUnavailableTitle: string;
  interviewSchedulingUnavailableBody: string;
  interviewSchedulingGenericErrorTitle: string;
  interviewSchedulingGenericErrorBody: string;
  /**
   * Moving an existing booking. The noun keys stand in for a kind of booking this build has never
   * heard of — `bookingUsageDefault` is what an unknown `usage` falls back to, so it must read
   * sensibly on its own.
   */
  bookingUsageInterview: string;
  bookingUsageOnboarding: string;
  bookingUsageDefault: string;
  bookingRescheduleTitle: string;
  bookingRescheduleBody: string;
  bookingRescheduleCurrentTitle: string;
  bookingRescheduleFieldOrganizer: string;
  bookingRescheduleFieldCurrentTime: string;
  bookingRescheduleFieldNewTime: string;
  bookingRescheduleWindowFrom: (from: string) => string;
  bookingRescheduleWindowBetween: (from: string, to: string) => string;
  bookingReschedulePickNewTime: string;
  bookingRescheduleContinue: string;
  bookingRescheduleConfirmTitle: string;
  bookingRescheduleConfirmBody: string;
  // The same confirmation, for a candidate who kept their time and only changed how the interview
  // is held. The default pair announces a move, which here would not be true.
  bookingRescheduleChannelOnlyTitle: string;
  bookingRescheduleChannelOnlyBody: string;
  // And the ending for it — the prototype's `doneChannel`. Its handover names reusing the moved title
  // as a bug: "someone who switches video to phone without touching the time is told Your call has
  // moved, which is not true."
  bookingRescheduleDoneChannelTitle: string;
  // One line above the button, on a switch back to a video call: the old join link stops working and
  // a new one is issued, which the candidate has to be told before they confirm rather than after.
  bookingRescheduleNewLinkNotice: string;
  bookingRescheduleConfirmButton: string;
  bookingRescheduleOutsideWindowTitle: string;
  bookingRescheduleOutsideWindowBody: string;
  bookingOutsideWindowTitle: string;
  bookingOutsideWindowBody: string;
  bookingRescheduleDoneTitle: string;
  bookingRescheduleDoneBody: (email: string) => string;
  bookingRescheduleDoneBodyFallback: string;
  bookingRescheduleOldLinkVoid: string;
  bookingRescheduleChangeAgain: string;
  /** Shown both on arrival after the window shut and when it closes mid-flow. */
  bookingRescheduleClosedTitle: string;
  bookingRescheduleClosedBody: string;
  bookingRescheduleNotFoundTitle: string;
  bookingRescheduleNotFoundBody: string;
  viewFullJob: string;
  applyNow: string;
  notifyMeAboutNewJobs: string;
  imNotLookingRightNow: string;
  youreSetUpForNewMatchAlerts: string;
  stopAlerts: string;
  percentMatch: (percent: number) => string;
  noJobRecommendationsTitle: string;
  noJobRecommendationsMessage: string;
  hereAreJobsThatFitYourProfile: (count: number) => string;
  robinUsesYourActivityOnThisPageForBetterMatches: string;
  rejectCandidateModalTitle: string;
  rejectCandidateModalDescription: string;
  rejectCandidateReasonNotEnoughExperience: string;
  rejectCandidateReasonMissingCertificate: string;
  rejectCandidateReasonNotAvailableForHours: string;
  rejectCandidateReasonLivesTooFar: string;
  rejectCandidateReasonPositionFilled: string;
  rejectCandidateReasonOther: string;
  rejectCandidateCustomReasonPlaceholder: string;
  rejectCandidateSubmit: string;
  rejectCandidate: string;
  sendInterviewInvite: string;
  rejected: string;
  candidateRejectedSuccessfully: string;
  candidateAppliedRecommendation: string;
  whyYouAreTheRightFit: string;
  interestedInThisOpportunity: string;
  backToJobList: string;
  pauseJobRecommendationsTitle: string;
  pauseJobRecommendationsDescription: string;
  pauseJobRecommendationsConfirm: string;
  pauseJobRecommendationsKeepShowing: string;
  /** The staff-only Indeed outreach monitor under /admin/outreach. */
  outreachMonitor: OutreachMonitorDictionary;
};

/**
 * Grouped rather than flat: the admin screen needs a hundred-odd strings that nothing else reads, and
 * a group keeps them from crowding the shared namespace. Keys under `healthLabels`, `outreachGates`,
 * `messagesGates` and `queueStatuses` are the server's own codes, so a lookup by code needs no map.
 */
export type OutreachMonitorDictionary = {
  navLabel: string;
  pageTitle: string;
  pageDescription: string;
  impersonating: string;
  stopImpersonating: string;
  tabs: { searches: string; installs: string; queue: string; intervals: string };
  refresh: string;
  retry: string;
  loadFailed: (status: number | null) => string;
  lookupFailed: string;
  pageRange: (from: number, to: number, count: number) => string;
  previousPage: string;
  nextPage: string;
  never: string;
  filters: {
    company: string;
    companyPlaceholder: string;
    recruiter: string;
    recruiterPlaceholder: string;
    recruiterNeedsCompany: string;
    health: string;
    healthAll: string;
    healthAny: string;
    search: string;
    searchPlaceholder: string;
    advertiserKey: string;
    advertiserKeyPlaceholder: string;
    clear: string;
  };
  healthy: string;
  healthLabels: {
    no_report: string;
    indeed_session_invalid: string;
    no_credits: string;
    no_project: string;
    indeed_queue_stuck: string;
    claim_stuck: string;
    failed_recently: string;
    limit_reached: string;
  };
  healthDescriptions: {
    no_report: string;
    indeed_session_invalid: string;
    no_credits: string;
    no_project: string;
    indeed_queue_stuck: string;
    claim_stuck: string;
    failed_recently: string;
    limit_reached: string;
  };
  outreachGates: {
    no_campaigns: string;
    no_header_rule: string;
    session_invalid: string;
    no_credits: string;
    no_sender: string;
    no_project_list: string;
    ready: string;
  };
  messagesGates: {
    forced: string;
    disabled: string;
    no_header_rule: string;
    session_invalid: string;
    session_valid: string;
  };
  queueStatuses: {
    indeed_waiting: string;
    extension_queued: string;
    in_progress: string;
    pending: string;
  };
  searches: {
    columns: {
      health: string;
      company: string;
      search: string;
      owner: string;
      automation: string;
      indeed: string;
      queue: string;
      used: string;
      lastRun: string;
    };
    automationOn: string;
    automationOff: string;
    threshold: (threshold: number) => string;
    untitled: string;
    ids: (campaignId: number, chatId: number) => string;
    indeedBrowsers: (enabled: number, total: number) => string;
    noBrowsers: string;
    queueCell: (waiting: number, claimed: number, pending: number) => string;
    usedCell: (channel: string, used: number, limit: number) => string;
    empty: string;
  };
  detail: {
    close: string;
    settings: string;
    owner: string;
    sender: string;
    senderSources: { ats_owner: string; recruiter: string };
    nobody: string;
    lastRun: string;
    limits: string;
    channelEmailWhatsapp: string;
    channelIndeed: string;
    limitSearch: string;
    limitInherits: string;
    limitCompanyDefault: string;
    limitMaximum: string;
    limitUsed: string;
    limitBlockedBy: string;
    blockedBy: (value: string) => string;
    notBlocked: string;
    tenantCap: string;
    tenantCapNone: string;
    queue: string;
    queuePending: string;
    queueIndeedWaiting: string;
    queueExtensionQueued: string;
    queueInProgress: string;
    queueCompleted24h: string;
    queueFailed24h: string;
    oldestClaim: (when: string) => string;
    lastIndeedActivity: (when: string) => string;
    noIndeedActivity: string;
    browsers: string;
    browsersEmpty: string;
    openQueue: string;
    openOwnerIntervals: string;
  };
  install: {
    indeedOn: string;
    indeedOff: string;
    project: (name: string) => string;
    projectNotPicked: string;
    projectMissing: (name: string | null) => string;
    projectUnchecked: string;
    gate: (gate: string) => string;
    sessionValid: string;
    sessionInvalid: string;
    sessionUnknown: string;
    credits: (credits: number) => string;
    creditsUnlimited: string;
    creditsUnknown: string;
    stalledSince: (when: string) => string;
    advertiserKey: (key: string) => string;
    lastSeen: (when: string) => string;
    version: (version: string) => string;
    queue: string;
    intervals: string;
  };
  installs: {
    columns: {
      recruiter: string;
      indeed: string;
      version: string;
      lastSeen: string;
      advertiserKey: string;
      intervals: string;
      config: string;
      outreachGate: string;
      actions: string;
    };
    connection: { connected: string; disconnected: string; unknown: string; no_report: string };
    intervalsCell: (messageMinutes: number | null, outreachMinutes: number | null) => string;
    config: {
      applied: (version: number) => string;
      pending: (applied: number | null, latest: number) => string;
      no_override: string;
      unknown: (applied: number | null) => string;
    };
    reported: (when: string) => string;
    nextCycle: (when: string) => string;
    nextCycleDue: string;
    nextCycleOverdue: (when: string) => string;
    noOutreachReport: string;
    empty: string;
  };
  queue: {
    scopeSearch: (label: string) => string;
    scopeRecruiter: (label: string) => string;
    scopeInstall: (installId: string) => string;
    scopeAdvertiser: (key: string) => string;
    noScope: string;
    clearScope: string;
    status: string;
    statusAll: string;
    columns: {
      score: string;
      candidate: string;
      search: string;
      status: string;
      attempts: string;
      created: string;
      updated: string;
    };
    orderNote: string;
    empty: string;
  };
  intervals: {
    pickRecruiter: string;
    title: (name: string) => string;
    message: string;
    outreach: string;
    help: (min: number, max: number, defaultMinutes: number) => string;
    expiresAt: string;
    noExpiry: string;
    noExpiryHelp: string;
    save: string;
    reset: string;
    saved: string;
    resetDone: string;
    saveFailed: string;
    errors: {
      not_integer: string;
      below_min: (min: number) => string;
      above_max: (max: number) => string;
      expiry_missing: string;
      expiry_invalid: string;
      expiry_past: string;
    };
    statusNone: string;
    statusActive: (version: number) => string;
    statusExpired: (version: number) => string;
    expiresOn: (when: string) => string;
    neverExpires: string;
    updatedBy: (name: string, when: string) => string;
    jitterNote: string;
    applyNote: string;
    browsers: string;
    browsersEmpty: string;
    browserApplied: (version: number) => string;
    browserPending: (applied: number | null, latest: number) => string;
    browserNoOverride: string;
  };
};

export type SupportedLanguage = 'en' | 'nl';

export type SupportedLocale = 'en-US' | 'nl-NL';

export type ContextProps = {
  language: SupportedLanguage;
  dictionary: Dictionary;
  locale: SupportedLocale;
  setLanguage: any;
};

export type LocalizationContextProviderProps = {
  children: React.ReactNode;
};

export type MetaExperience = {
  first?: number;
  last?: number;
  gap?: number;
};

type SelectAnTemplateToUseTypes =
  | 'whatsapp'
  | 'email'
  | 'phone'
  | 'linkedin'
  | 'indeed'
  | 'werknl'
  | 'rj_communication_hub';

export const DICTIONARY_LINKS = {
  ROBIN_EXTENSION: 'https://help.recruitrobin.com/nl/articles/10342349-hoe-werk-ik-met-indeed',
  EXISTING_SUBSCRIPTION: 'https://help.recruitrobin.com/nl/articles/10342349-hoe-werk-ik-met-indeed',
  BUY_NEW_SUBSCRIPTION: 'https://help.recruitrobin.com/nl/articles/10342349-hoe-werk-ik-met-indeed',
  INDEED_KNOW_MORE: 'https://help.recruitrobin.com/nl/articles/10342349-hoe-werk-ik-met-indeed',
};
